import { Data } from 'signup-constants/signupData/Data';
import { LayoutType } from 'signup-components/types';
import { Step } from 'signup-constants/Step';
import { DataOptions } from '../signup-data/signupDataOptions';
import { BaseButtonsView } from './BaseButtonsView';
import { useLayoutTemplate } from '../hooks/useLayoutTemplate';
import { jsx as _jsx } from "react/jsx-runtime";
const CompanySizeView = () => {
  const options = DataOptions[Data.CompanySize];
  const {
    layoutType
  } = useLayoutTemplate();
  const isSidePanel = layoutType === LayoutType.SidePanel;
  return /*#__PURE__*/_jsx(BaseButtonsView, {
    helperTextString: isSidePanel ? `views.${Step.CompanySize}.sidePanelHelperText` : undefined,
    helperTitleKey: isSidePanel ? `views.${Step.CompanySize}.title.sidePanel` : undefined,
    options: options,
    shouldCenterLastRow: true,
    shouldDisableAutofocus: true
  });
};
export default CompanySizeView;